import React from 'react'
import { Collapse, Result, Space } from 'antd'
import Answer from './answer/Answer'
import { useFetchQuestionsQuery } from '../../../../../../store/apis/question.api'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router'
import { textSubmissionDrawerActions } from '../../../../../../store/slices/text-submission-drawer.slice'
import textSubmissionDrawerSelectors from '../../../../../../store/selectors/text-submission-drawer.selectors'
import assignmentSelectors from '../../../../../../store/selectors/assignment.selectors'
import { useFetchTextSubmissionDetailsQuery } from '../../../../../../store/apis/submission.api'
import {
    useQuestionFocusNavigationShortcuts,
    useScrollToFirstEscalatedOnMount,
    useScrollToFocusedQuestion,
} from '../../../../../../store/apis/utils/hooks/text-submission.hooks'
import { useVersionId } from '../../../../../../utils/parseURL.helper'
import AssigneeList from './AssigneeList'

const Answers = ({ submissionId }) => {
    const expandedQuestionIds = useSelector(textSubmissionDrawerSelectors.expandedQuestionIds)
    const isOwner = useSelector(assignmentSelectors.isOwner)
    const dispatch = useDispatch()
    const { token } = useParams()
    const versionId = useVersionId()
    const {
        data: submission,
        isFetching: isFetchingSubmission,
        error: errorFetchingSubmission,
    } = useFetchTextSubmissionDetailsQuery({ submissionId })
    const { data: questions } = useFetchQuestionsQuery({ token, versionId })

    useQuestionFocusNavigationShortcuts()
    useScrollToFirstEscalatedOnMount(submissionId)
    useScrollToFocusedQuestion(isFetchingSubmission)

    const items = questions?.map(question => ({
        key: question.id,
        label: <Space>{question?.name || question?.content}</Space>,
        children: (
            <Answer
                submissionId={submissionId}
                answers={submission?.answers}
                loading={isFetchingSubmission}
                question={question}
            />
        ),
        extra: isOwner ? <AssigneeList question={question} submission={submission} /> : null,
    }))

    const onChange = expandedQuestionKeys => {
        const numericKeys = expandedQuestionKeys.map(Number)
        dispatch(textSubmissionDrawerActions.setExpandedQuestionIds(numericKeys))

        const lastOpenedQuestion = questions.find(question => question.id === numericKeys.at(-1))
        if (lastOpenedQuestion)
            dispatch(
                textSubmissionDrawerActions.setFocusedQuestionId(
                    lastOpenedQuestion.children ? lastOpenedQuestion.children[0].id : lastOpenedQuestion.id,
                ),
            )
    }
    if (errorFetchingSubmission) return <Result status='error' title='Submission fetch failed' />
    return <Collapse activeKey={expandedQuestionIds} onChange={onChange} items={items} size='small' bordered={false} />
}

export default Answers
